<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="User guide" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="1) Registration"
        >
          <div class="text-container">
            <span class="text">Membership registration (free of charge) is required to use this site.</span>
            <span class="text">We recommend using a Gmail email address.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="2) Point Purchase"
          id="howtopay"
        >
          <div class="text-container">
            <span class="text">・All products can be purchased with points.</span>
            <span class="text">・Therefore, please purchase points first.</span>
            <span class="text">・1P = 1 yen, and you can choose from 300P to 50,000P.</span>
            <span class="text">*There are four types of payment methods available : credit card payment, convenience store payment, bank transfer, and PayPal.</span>
            <br>
            <span class="text">・If you wish to use Melpay or PayPay, you can also purchase points at the "minny mail order store's homepage or minny Omiya store's cashier.</span>
            <span class="text">・Please use the checkout page of the minny Omiya store.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="3) Purchase"
          id="howtosend"
        >
          <div class="text-container">
            <span class="text">Tap the product you want and select the number of packs you want to purchase.</span>
            <span class="text">Then production movie will be played.</span>
            <span class="text">The tints shown in the movie will be changed according to the cards you win.</span>
            <span class="text">The production video will be played the same number of times as the number of purchases, but it can be skipped.</span>
            <br>
            <span class="text">After that, you will be asked to choose either "Convert to Points" or "Shipping Request" for each card.</span>
            <span class="text">Once you have made your decision, it is impossible to change it later, so please be careful.</span>
            <span class="text">If you do not make your choice within 24 hours, the card will automatically be converted to points.</span>
            <span class="text">Please forgive us in advance.</span>
            <br>
            <span class="text">If you choose "Convert to Point"</span>
            <span class="text">You will receive points that can be used on our website in place of the card that was ejected.</span>
            <br>
            <span class="text">*The conversion rate to points is based on the market value of the winning card.</span>
            <br>
            <span class="text">If you choose "Request for shipment"</span>
            <span class="text">We will send you the card you won.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserGuide',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: $white;
  @include appendMap($backgroundStyleMap);
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: $white;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
  .center {
    text-align: left;
  }
}
</style>
